import { Button } from '@/components/button';
import VideoPlayer from './VideoPlayer';
import CardContainer from './CardContainer';

interface LevelUpCardProps {
  title: string;
  level: number;
  videoSrc: string;
  onLevelUp: VoidFunction;
}

const LevelUpCard: React.FC<LevelUpCardProps> = ({ title, level, videoSrc, onLevelUp }: LevelUpCardProps) => {
  return (
    <CardContainer hasBlueBorder>
      <div className='flex flex-col items-center px-8 pt-8'>
        <p className='text-[32px] font-bold text-text-primary'>{title}</p>
        <p className='text-xl font-medium text-text-secondary'>You evolved to Level {level}</p>
      </div>
      <div className='flex-1 overflow-hidden'>
        <VideoPlayer src={videoSrc} className='w-full h-full object-contain' />
      </div>
      <div className='flex justify-center p-8'>
        <Button size='large' variant='primary' onClick={onLevelUp}>
          Level Up
        </Button>
      </div>
    </CardContainer>
  );
};

export default LevelUpCard;
